var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("normalDialog", {
    attrs: {
      title: _vm.$t(
        "label_essweb_myLeaveApplication_list_dialog_newLeaveTitle"
      ),
      dialog: _vm.show,
      width: "800",
    },
    on: { close: _vm.closeDialog },
    scopedSlots: _vm._u([
      {
        key: "content",
        fn: function () {
          return [
            _c("Tabler", {
              attrs: {
                headers: _vm.headers,
                items: _vm.desserts,
                showHeader: false,
                needScrollX: false,
              },
              scopedSlots: _vm._u([
                {
                  key: "item.type",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _c("div", { staticClass: "table-title text--primary" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$getCommonLangValue(item.leave_type_name)
                            ) +
                            " "
                        ),
                      ]),
                    ]
                  },
                },
                {
                  key: "item.unit",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _c("div", { staticClass: "text--primary table-title" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              item.unit == "D"
                                ? _vm.$t("label_essweb_system_dayLabel")
                                : item.unit == "H"
                                ? _vm.$t("label_essweb_system_hourLabel")
                                : _vm.$t("label_essweb_system_minutesLabel")
                            ) +
                            " "
                        ),
                      ]),
                    ]
                  },
                },
                {
                  key: "item.pending",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      Number(item.is_show_pending)
                        ? _c(
                            "div",
                            { staticClass: "text--primary table-title" },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm._f("CalculationByDHFilter")(
                                      item.leave_pending,
                                      item,
                                      _vm.CalculationByDH
                                    )
                                  ) +
                                  " "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]
                  },
                },
                {
                  key: "item.balance",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      Number(item.is_show_balance)
                        ? _c(
                            "div",
                            { staticClass: "text--primary table-title" },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm._f("CalculationByDHFilter")(
                                      item.leave_balance,
                                      item,
                                      _vm.CalculationByDH
                                    )
                                  ) +
                                  " "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]
                  },
                },
                {
                  key: "item.action",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      Number(item.is_allow_apply)
                        ? _c(
                            "v-btn",
                            {
                              staticClass: "text-button",
                              attrs: {
                                rounded: "",
                                color: "primary",
                                small: "",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.toApply(item.leave_type_uuid)
                                },
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t(
                                      "label_essweb_LeaveApplication_list_dialog_applyBtnLabel"
                                    )
                                  )
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]
                  },
                },
              ]),
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }